// extracted by mini-css-extract-plugin
export default {"jsonHeader":"AdminTab_jsonHeader__EgaCr","prettyJson":"AdminTab_prettyJson__XMN4I","jsonColumn":"AdminTab_jsonColumn__u1A6z","loadMoreButton":"AdminTab_loadMoreButton__BZPfL"};